import axios  from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const DecompteMissionService = {
    async findMissionsForDecompte(filters = {}) {
        const queryParams = new URLSearchParams();
        ['date_begin', 'date_end', 'reference', 'mission', 'status'].forEach((field) => {
            if (filters[field]) {
                queryParams.append(field, filters[field]);
            }
        });
        try {
            const url = queryParams.toString()
                ? `${apiUrl}/DecompteMission?${queryParams.toString()}`
                : `${apiUrl}/DecompteMission`;
            const response = await axios.get(url);
            if (response) {
                return response.data;
            }
        }
        catch (error) {
            console.error("Error fetching missions for decompte:", error);
            throw error;
        }
    },

    async findMissionsForAccountingValidation(filters = {}) {
        const queryParams = new URLSearchParams();
        ['date_begin', 'date_end', 'reference', 'mission', 'status'].forEach((field) => {
            if (filters[field]) {
                queryParams.append(field, filters[field]);
            }
        });

        const query = queryParams.toString();
        const url = query
            ? `${apiUrl}/DecompteMission/accounting?${query}`
            : `${apiUrl}/DecompteMission/accounting`;

        try {
            const response = await axios.get(url);
            return response?.data;
        } catch (error) {
            console.error('Error fetching missions for accounting validation:', error);
            throw error;
        }
    },

    async getAccountingDecompteDetail(mission_decompte_id) {
        try {
            const response = await axios.get(`${apiUrl}/DecompteMission/accountingDetail`, {
                params: { mission_decompte_id }
            });
            return response?.data;
        } catch (error) {
            return error.response?.data || {
                status: false,
                message: 'Erreur lors du chargement du decompte.'
            };
        }
    },
    async saveDecompte(formData){
        try{
            const response = await axios.post(`${apiUrl}/DecompteMission`, formData);
            if(response){
                return response.data;
            }
        }catch(error){
            if(error.response){
                return error.response.data;
            }
            throw error;
        }
    },

    async sendAndGenerate(mission_planning_id, mission_planning_agenda_id, mission_timesheet_id, transport_id, mission_decompte_id){
        try{
            const response = await axios.get(`${apiUrl}/DecompteMission/sendAndGenerate`, {
                params: {
                    mission_planning_id,
                    mission_planning_agenda_id,
                    mission_timesheet_id,
                    transport_id,
                    mission_decompte_id
                }
            });
            if(response){
                return response.data;
            }
        }catch(error){
            if(error.response){
                return error.response.data;
            }
            throw error;
        }
    },

    async downloadAccountingArchive(mission_decompte_id){
        return axios.get(`${apiUrl}/DecompteMission/accountingArchive`, {
            params: { mission_decompte_id },
            responseType: 'blob'
        });
    },

    async retrieveDestinationsDecompte(mission_planning_id, mission_planning_agenda_id, mission_timesheet_id, transport_id, decompte_id = null){
        try{
            const result = await axios.get(`${apiUrl}/DecompteMission/destinationsDecompte/`, {
                params: {
                    mission_planning_id,
                    mission_planning_agenda_id,
                    mission_timesheet_id,
                    transport_id,
                    decompte_id
                }
            }); 
            if (result) {
                return result.data;
            }
            } catch (err){
                if (err.response) {
                    return err.response.data;
                }
            }
    },

    async getHistory(mission_decompte_id){
        try{
            const result = await axios.get(`${apiUrl}/DecompteMission/history`, {
                params: { mission_decompte_id }
            });
            if(result){
                return result.data;
            }
        }catch(error){
            if(error.response){
                return error.response.data;
            }
            throw error;
        }
    },

    async validateDecompte(mission_decompte_id){
        try{
            const result = await axios.get(`${apiUrl}/DecompteMission/validateDecompte`, {
                params: { mission_decompte_id }
            });
            if(result){
                return result.data;
            }
        }catch(error){
            if(error.response){
                return error.response.data;
            }
            throw error;
        }
    },

    async refuseAccountingDecompte(mission_decompte_id, observation){
        try{
            const result = await axios.post(`${apiUrl}/DecompteMission/accountingRefuse`, {
                mission_decompte_id,
                observation
            });
            return result?.data;
        }catch(error){
            return error.response?.data || {
                status: false,
                message: 'Erreur lors du refus du decompte.'
            };
        }
    },

    async refuseDecompte(mission_decompte_id, transport_id, observation){
        try{
            const result = await axios.post(`${apiUrl}/DecompteMission/refuseDecompte`, {
                mission_decompte_id,
                transport_id,
                observation
            });
            if(result){
                return result.data;
            }
        }catch(error){
            if(error.response){
                return error.response.data;
            }
            throw error;
        }
    }

}

export default DecompteMissionService;
